/**
 * usePinnedDashboards — the saved views listed in the simplified rail's
 * Dashboards accordion, scoped to the active module.
 */
import { useQuery } from '@tanstack/react-query';
import { listDashboardsOptions } from '../generated/api/@tanstack/react-query.gen.js';

export function usePinnedDashboards(moduleId: string) {
  const query = useQuery({
    ...listDashboardsOptions({ query: { ...(moduleId && moduleId !== 'all' ? { moduleId } : {}), pinned: true } }),
    select: (list) => list.data ?? [],
  });
  if (query.isError) console.error('usePinnedDashboards: failed to load pinned dashboards', query.error);
  return query;
}
